<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras nombre_ruta="quienesSomos"></boton-atras>

             <div>
                <div>
                    <h6 class="subtitulo mb-2">Organigrama</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                </div>
                <div class="text-center bg-light">
                    <img src="@/assets/imagenes/organigrama.svg">         
                </div>
            </div>
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
/* 
@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}

.contenido_principal img{ width: 80%; } */

</style>